module.exports = __webpack_public_path__ + "static/media/setting.60bb5cba.svg";